var map = {
	"./template.bet575": 1896,
	"./template.bet575.tsx": 1896,
	"./template.bet777": 1897,
	"./template.bet777.tsx": 1897,
	"./template.betgalaxy": 1898,
	"./template.betgalaxy.tsx": 1898,
	"./template.betprofessor": 1899,
	"./template.betprofessor.tsx": 1899,
	"./template.betroyale": 2146,
	"./template.betroyale.tsx": 2146,
	"./template.betstride": 1900,
	"./template.betstride.tsx": 1900,
	"./template.buffalobet": 1901,
	"./template.buffalobet.tsx": 1901,
	"./template.chromabet": 1902,
	"./template.chromabet.tsx": 1902,
	"./template.default": 55,
	"./template.default.tsx": 55,
	"./template.epicodds": 1903,
	"./template.epicodds.tsx": 1903,
	"./template.fiestabet": 1904,
	"./template.fiestabet.tsx": 1904,
	"./template.forsport": 1905,
	"./template.forsport.tsx": 1905,
	"./template.gigabet": 1906,
	"./template.gigabet.tsx": 1906,
	"./template.goldenbet888": 1907,
	"./template.goldenbet888.tsx": 1907,
	"./template.goldenrush": 1908,
	"./template.goldenrush.tsx": 1908,
	"./template.hyperbet": 1909,
	"./template.hyperbet.tsx": 1909,
	"./template.juicybet": 1910,
	"./template.juicybet.tsx": 1910,
	"./template.junglebet": 1911,
	"./template.junglebet.tsx": 1911,
	"./template.magnumbet": 1912,
	"./template.magnumbet.tsx": 1912,
	"./template.oldgill": 1913,
	"./template.oldgill.tsx": 1913,
	"./template.puntcity": 1914,
	"./template.puntcity.tsx": 1914,
	"./template.puntgenie": 2031,
	"./template.puntgenie.tsx": 2031,
	"./template.pyramidbet": 1915,
	"./template.pyramidbet.tsx": 1915,
	"./template.questbet": 2147,
	"./template.questbet.tsx": 2147,
	"./template.slambet": 1916,
	"./template.slambet.tsx": 1916,
	"./template.sterlingparker": 2148,
	"./template.sterlingparker.tsx": 2148,
	"./template.sugarcastle": 1917,
	"./template.sugarcastle.tsx": 1917,
	"./template.templebet": 1918,
	"./template.templebet.tsx": 1918,
	"./template.titanbet": 1919,
	"./template.titanbet.tsx": 1919,
	"./template.ts": 999,
	"./template.vikingbet": 1920,
	"./template.vikingbet.tsx": 1920,
	"./template.volcanobet": 1921,
	"./template.volcanobet.tsx": 1921,
	"./template.wellbet": 1922,
	"./template.wellbet.tsx": 1922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2794;